module.exports = __webpack_public_path__ + "img/text22.3c2cfffb.webp";